import { render } from "./categoryList.vue?vue&type=template&id=5e465d1c"
import script from "./categoryList.vue?vue&type=script&lang=js"
export * from "./categoryList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__